import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var CurriculaService = /** @class */ (function () {
    function CurriculaService(http) {
        this.http = http;
    }
    CurriculaService.prototype.getCurriculum = function (applier_id, event_id) {
        var queryParams = '?language=it';
        if (event_id) {
            queryParams += '&event_id=' + event_id;
        }
        return this.http.get(environment.baseUrlWs + environment.wsVerison + 'employer/user/' + applier_id + '/' + queryParams);
    };
    // employer/jobs/get-applications/?candidates_id=330217
    CurriculaService.prototype.getApplications = function (applier_id, job_id) {
        if (job_id === void 0) { job_id = false; }
        var queryParams = '';
        if (job_id) {
            queryParams = '?jobs_id=' + job_id;
        }
        return this.http.get(environment.baseUrlWs + 'v2/employer/jobs/get-applications/' + applier_id + '/' + queryParams);
    };
    CurriculaService.prototype.getCheckIns = function (users_id) {
        var queryParams = '?users_id=' + users_id;
        return this.http.get(environment.baseUrlWs + environment.wsVerison + 'employer/events/get-check-ins/' + users_id);
    };
    CurriculaService.prototype.saveApplicationComment = function (application) {
        return this.http.put(environment.baseUrlWs + environment.wsVerison + 'employer/jobs/' + application['applications_id'] + '/curriculum-save-comment', { comment: application['comments'] });
    };
    CurriculaService.prototype.saveCheckInComment = function (checkIn) {
        return this.http.put(environment.baseUrlWs + environment.wsVerison + 'employer/events/' + checkIn['events_id'] + '/add-comment-to-user', {
            comments: checkIn['comments'],
            users_id: checkIn['users_id']
        });
    };
    //////////
    CurriculaService.prototype.getCurriculaPage = function (applicationId, page) {
        if (page === void 0) { page = 0; }
        var url = "" + environment.baseUrlWs + environment.wsVerison + "employer/curricula/" + applicationId + "/pages/" + page;
        return this.http.get(url, { observe: 'response', responseType: 'arraybuffer' });
    };
    CurriculaService.prototype.getCurriculaPdf = function (applicationId) {
        var url = "" + environment.baseUrlWs + environment.wsVerison + "employer/curricula/" + applicationId + "/cv";
        return this.http.get(url, { observe: 'response', responseType: 'arraybuffer' });
    };
    CurriculaService.prototype.putApplicationComment = function (applicationId, comment) {
        var url = "" + environment.baseUrlWs + environment.wsVerison + "employer/jobs/" + applicationId + "/curriculum-save-comment";
        return this.http.put(url, { comment: comment });
    };
    CurriculaService.ngInjectableDef = i0.defineInjectable({ factory: function CurriculaService_Factory() { return new CurriculaService(i0.inject(i1.HttpClient)); }, token: CurriculaService, providedIn: "root" });
    return CurriculaService;
}());
export { CurriculaService };
